"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
class CallLimitier {
  constructor(fn, interval) {
    this.fn = fn;
    this.interval = interval || 20;
  }
  register(fn, ctx) {
    this.fn = fn;
  }
  get tm() {
    return this._tm;
  }
  set tm(value) {
    this._tm = value;
  }
  invoke() {
    let args = arguments;
    if (this.tm) {
      clearTimeout(this.tm);
    }
    let currentTm = this.tm = (0, _setTimeout2.default)(() => {
      let canceled = {
        isCancaled: () => this.tm !== currentTm
      };
      this.fn.call(null, ...args, canceled);
    }, this.interval);
  }
}
var _default = exports.default = CallLimitier;